export default __webpack_public_path__ + "static/media/yu.8e7ab691.svg";